export default {"src":"/login-app/[GIT_HASH]/_next/static/media/approved.4bcbfc87.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};